export default "assets/images/quotes-arrow-50d57841.svg";